import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconHamburger = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.33333 7C7.14924 7 7 7.14924 7 7.33333V16.6667C7 16.8508 7.14924 17 7.33333 17H7.66667V12.6667C7.66667 12.1144 8.11438 11.6667 8.66667 11.6667H15.3333C15.8856 11.6667 16.3333 12.1144 16.3333 12.6667V17H16.6667C16.8508 17 17 16.8508 17 16.6667V9.74755L14.2525 7H9.66667V8.33333H14V10.3333H8.66667C8.11438 10.3333 7.66667 9.88562 7.66667 9.33333V7H7.33333ZM14.3333 17H9.66667V13.6667H14.3333V17ZM5 7.33333C5 6.04467 6.04467 5 7.33333 5H14.6667C14.9319 5 15.1862 5.10536 15.3738 5.29289L18.7071 8.62623C18.8946 8.81376 19 9.06812 19 9.33333V16.6667C19 17.9553 17.9553 19 16.6667 19H7.33333C6.04467 19 5 17.9553 5 16.6667V7.33333Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 9H5V7H19V9ZM19 13H5V11H19V13ZM5 17H19V15H5V17Z"
        />
      </svg>
    );
  }
);
